import standardApiRequestAction from 'my-core/standardApiRequestAction';

export function fetchManagerOnlineCourseQuestions(fetchParams, requestKey, page) {
  return standardApiRequestAction({
    path: '/api/v1/online_course_questions/manager',
    parentRequestKey: requestKey,
    requestKey: page,
    body: fetchParams,
  });
}

export function fetchActivityOnlineCourseQuestions(fetchParams, requestKey, page) {
  return standardApiRequestAction({
    path: '/api/v1/online_course_questions/activity',
    parentRequestKey: requestKey,
    requestKey: page,
    body: fetchParams,
  });
}

export function createOnlineCourseQuestion(params) {
  return standardApiRequestAction({
    path: '/api/v1/online_course_questions',
    method: 'post',
    body: params,
  });
}

export function updateOnlineCourseQuestion(id, body) {
  return standardApiRequestAction({
    path: `/api/v1/online_course_questions/${id}`,
    method: 'patch',
    body,
  });
}

export function escalateOnlineCourseQuestion(id) {
  return standardApiRequestAction({
    path: `/api/v1/online_course_questions/${id}/escalate`,
    method: 'post',
  });
}

export function deleteOnlineCourseQuestion(id) {
  return standardApiRequestAction({
    path: `/api/v1/online_course_questions/${id}`,
    method: 'delete',
    destroy: { onlineCourseQuestions: [id] },
  });
}

export function createOnlineCourseQuestionReply(questionId, params, viewing) {
  return standardApiRequestAction({
    path: `/api/v1/online_course_questions/${questionId}/replies`,
    method: 'post',
    body: { online_course_question_reply: params, viewing },
  });
}

export function updateOnlineCourseQuestionReply(replyId, params) {
  return standardApiRequestAction({
    path: `/api/v1/online_course_question_replies/${replyId}`,
    method: 'patch',
    body: { online_course_question_reply: params },
    instantUpdate: { onlineCourseQuestionReplies: [{ id: replyId, ...params }] },
  });
}

export function deleteOnlineCourseQuestionReply(id) {
  return standardApiRequestAction({
    path: `/api/v1/online_course_question_replies/${id}`,
    method: 'delete',
    destroy: { onlineCourseQuestionReplies: [id] },
  });
}
